export default "__VITE_ASSET__CYQGLm7s__"